import { render, staticRenderFns } from "./CustomerSection.vue?vue&type=template&id=c5b6f8b6&"
import script from "./CustomerSection.vue?vue&type=script&lang=js&"
export * from "./CustomerSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports